// extracted by mini-css-extract-plugin
module.exports = {"bb-our-focus":"bb-our-focus__6aC6x","bb-our-focus__items":"bb-our-focus__items__FRITI","bb-our-focus__item":"bb-our-focus__item__VsXzt"};